import {
  fetchDeleteCategoryFailure,
  fetchDeleteCategorySuccess,
} from "./reducer";
import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { DELETE_CATEGORY } from "../../constants/constants";
import { getAllCategory } from "../GetCategory/thunk";

export const deleteCategory = (id, setLoading) => (dispatch) => {
  setLoading(true);

  determineBaseUrlAndPerformApiCall(DELETE_CATEGORY(id), "DELETE")
    .then((response) => {
      if (!response.error) {
        dispatch(getAllCategory(setLoading));
        dispatch(fetchDeleteCategorySuccess(response));
        setLoading(false);
        toast.success("Category Deleted Successfully");
      }

      if (response.error) {
        dispatch(fetchDeleteCategoryFailure(response.error.message));
        setLoading(false);
        toast.error(response.error.message);
      }
    })
    .catch((errorResp) => {
      dispatch(
        fetchDeleteCategoryFailure(
          errorResp?.message || "Something went wrong",
        ),
      );

      setLoading(false);
      toast.error(errorResp?.message || "Something went wrong");
    });
};
